import { useTranslation } from '@dagens/frontend-i18n';
import { FC } from 'react';

import { Optional } from '../../_common/components/input/FormLabel';

export const FormFieldOptional: FC = () => {
  const { t } = useTranslation();
  return <Optional>{t('common:optional')}</Optional>;
};
